import * as React from 'react';
export const useLayoutEffect = globalThis.document ? React.useLayoutEffect : React.useEffect;